export enum AdminAssetsQueryKeys {
	ADMIN_ASSETS = 'admin-assets',
	UPDATE_ADMIN_ASSETS = 'update-admin-assets',
}
